const initialState = () => ({
  readerReg: {
    personal: {
      id: "",
      firstName: "",
      lastName: "",
      email: "",
      cellNumber: "",
      profileImage: "",
      DOB: "",
      gender: "",
      isActive: true,
      languages: ""
    },
    credentials: {
      ruCertified: "",
      certDate: "",
      CAQH: "",
      NPI: "",
      license: "",
      practice: "",
      insurance: "",
      insuranceOther: ""
    },
    mailingAddress: {
      id: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      phone: "",
    },
    billingAddress: {
      id: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      businessPhone: "",
      website: ""
    },
    comments: {
      additionalNotes: ""
    },
    editInfo: {
      doctorID: "",
      personID: "",
      status: "",
      readerID: ""
    }
  }
})

const state = initialState()

const getters = {
  readerReg: (state) => state.readerReg,
  rdPersonal: (state) => state.readerReg.personal,
  rdCredentials: (state) => state.readerReg.credentials,
  rdBillingAddress: (state) => state.readerReg.billingAddress,
  rdMailingAddress: (state) => state.readerReg.mailingAddress,
  rdComments: (state) => state.readerReg.comments,
  rdEditInfo: (state) => state.readerReg.editInfo
}

const mutations = {
  RESET_READER_REG(state) {
    Object.assign(state, initialState())
  },
  SET_READER_REG(state, readerReg) {
    state.readerReg = readerReg
  }
}

const actions = {
  clearReaderReg({ commit }) {
    commit("RESET_READER_REG")
  },
  setReaderReg({ commit }, readerReg) {
    commit("SET_READER_REG", readerReg)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
